import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import axios from '../../../sharedModules/utils/axios.utils';
import { CollectionEmailSendDetail } from '../model';

export interface ForwardEmailResponse extends CollectionEmailSendDetail {
  skipped_attachments: string[];
}

interface ForwardEmailArgs {
  emailSendId: number;
  toEmails: string[];
  location: string;
}

const forwardEmail = ({ emailSendId, toEmails, location }: ForwardEmailArgs) =>
  axios.post<{ to_emails: string[]; location: string }, AxiosResponse<ForwardEmailResponse>>(
    `/collections/email_sends/${emailSendId}/forward`,
    {
      to_emails: toEmails,
      location,
    },
  );

export const useForwardEmail = () => {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: forwardEmail,
    onSuccess: () => {
      void queryClient.invalidateQueries({
        predicate: (q) => Array.isArray(q.queryKey) && q.queryKey[0] === '/collections/email_sends',
      });
    },
  });

  return {
    forwardEmail: mutation.mutateAsync,
    isLoading: mutation.isPending,
  };
};
